import { RootState } from '../store';

export const errorCount = (state: RootState) => state.patient.errors;

export const needsAuth = (state: RootState) => state.patient.needsAuth || [];

export const noReplySelector = (state: RootState) => !!state.patient['no_reply'];
